import React, { useCallback, useEffect, useState } from 'react'

export const usePrevNextButtons = ({
  emblaApi,
  handleSlideChange = () => {},
}) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
    handleSlideChange()
  }, [emblaApi, handleSlideChange])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
    handleSlideChange()
  }, [emblaApi, handleSlideChange])

  const onSelect = useCallback(emblaApi => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect).on('select', onSelect)
  }, [emblaApi, onSelect])

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  }
}

export const PrevButton = props => {
  const { children, ...restProps } = props

  return (
    <button
      className={`${props.disabled ? 'disabled' : ''} embla__button embla__button--prev`}
      type="button"
      {...restProps}
    >
      <svg
        className="embla__button__svg"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
      >
        <path
          stroke="#8B8B8B"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M14.898 7.947H1.004M7.953 1 1.006 7.947l6.947 6.948"
        />
      </svg>

      {children}
    </button>
  )
}

export const NextButton = props => {
  const { children, ...restProps } = props

  return (
    <button
      className={`${props.disabled ? 'disabled' : ''} embla__button embla__button--next`}
      type="button"
      {...restProps}
    >
      <svg
        className="embla__button__svg"
        svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="#8B8B8B"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M 14.898 7.947 L 1.004 7.947 M 7.953 1 L 1.006 7.947 L 7.953 14.895"
          transform="matrix(-1, 0, 0, -1, 15.902, 15.895)"
        />
      </svg>

      {children}
    </button>
  )
}
